import { withStyles } from '@material-ui/core';
import React from 'react';
import TrailerConstraints from './TrailerConstraints';
import { getTrailerCounts } from '../utils';
import { minutesToTime } from '@dataGrid/gridUtilities';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  otherConstraintsContainer: {
    display: 'flex',
    gap: '14px'
  },
  countItem: {
    color: theme.disableButtonText,
    fontWeight: 600
  }
});

const OptimizationConstraints = ({ classes, inputData, CommonStore, enableMaxStopsPerRouteInput }) => {
  const { trailers = [], maxStopsPerRoute, lastWaveCutOff, maxNumberOfTrips } = inputData;
  const trailerCounts = getTrailerCounts(trailers, CommonStore?.availableTrailers);
  return (
    <div className={classes.container}>
      <TrailerConstraints trailerCounts={trailerCounts} />
      <div className={classes.otherConstraintsContainer}>
        {enableMaxStopsPerRouteInput && (
          <div>
            Max stops per route <span className={classes.countItem}>{maxStopsPerRoute}</span>
          </div>
        )}
        <div>
          Last wave cut-off{' '}
          <span className={classes.countItem}>{minutesToTime({ value: lastWaveCutOff })}</span>
        </div>
        {maxNumberOfTrips > 0 && (
          <div>
            Max number of trips{' '}
            <span className={classes.countItem}>{maxNumberOfTrips}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(OptimizationConstraints);
